import { Component, OnInit, AfterViewInit, OnDestroy, HostListener } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import flatpickr from 'flatpickr';
import { Italian } from 'flatpickr/dist/l10n/it.js'; // Lingua italiana per Flatpickr
import { FunctionService } from '../../services/function.service';
import { initSnow } from '../../utils/snow.util';
import { ScheduledNoticeService } from '../../services/scheduled-notice.service';
import { ScheduledNoticeDTO } from '../../interfaces/scheduled-notice.interfaces';
import { Subscription } from 'rxjs';
import { ClientsBrands } from '../../services/routing.service';

@Component({
  selector: 'app-private-navbar',
  standalone: true,
  imports: [TranslateModule, FormsModule, CommonModule, RouterModule],
  templateUrl: './private-navbar.component.html',
  styleUrls: ['./private-navbar.component.css', './mobile-menu.css'],
})
export class PrivateNavbarComponent implements OnInit, AfterViewInit, OnDestroy {
  selectedCategory: string = 'products';
  searchInput: string = '';
  startDate: string = '';
  endDate: string = '';
  isSearchExpanded: boolean = false;
  mobileMenuOpen: boolean = false;

  // Avviso attualmente attivo
  activeNotice: ScheduledNoticeDTO | null = null;
  private noticeSubscription: Subscription = new Subscription();

  showBertaniVGILogos = false;
  clientsBrands: ClientsBrands[] = [];

  // Menu items della dashboard
  menuItems = [
    {
      title: 'DASHBOARD.CARDS.STATISTICS.TITLE',
      description: 'DASHBOARD.CARDS.STATISTICS.DESCRIPTION',
      icon: 'fas fa-chart-bar',
      route: '/statistics',
      permission: 'statistics',
      hasSubmenu: true,
      isExpanded: false,
      submenu: [
        {
          title: 'STATISTICS.AFFIDATI',
          icon: 'fas fa-handshake',
          route: '/statistics-affidati',
          permission: 'statistics-affidati'
        },
        {
          title: 'STATISTICS.CONSEGNATI',
          icon: 'fas fa-check-circle',
          route: '/statistics-consegnati',
          permission: 'statistics-consegnati'
        },
        {
          title: 'STATISTICS.BY_DAY',
          icon: 'fas fa-calendar-day',
          route: '/statistics-by-day',
          permission: 'statistics-by-day'
        },
        {
          title: 'STATISTICS.OPE_BY_DAY',
          icon: 'fas fa-calendar-day',
          route: '/statistics-ope-by-day',
          permission: 'statistics-ope-by-day'
        },
        {
          title: 'STATISTICS.RETURNS_BY_DAY',
          icon: 'fas fa-calendar-times',
          route: '/statistics-returns-by-day',
          permission: 'statistics-returns-by-day'
        },
        {
          title: 'STATISTICS.KPI_COLLI',
          icon: 'fas fa-chart-line',
          route: '/statistics-kpi-colli',
          permission: 'statistics-kpi-colli'
        }
      ]
    },
    {
      title: 'DASHBOARD.CARDS.OVERVIEW.TITLE',
      description: 'DASHBOARD.CARDS.OVERVIEW.DESCRIPTION',
      icon: 'fa-solid fa-box',
      route: '/overview',
      permission: 'overview',
      hasSubmenu: false
    },
    {
      title: 'DASHBOARD.CARDS.RETURNS.TITLE',
      description: 'DASHBOARD.CARDS.RETURNS.DESCRIPTION',
      icon: 'fas fa-exchange-alt',
      route: '/returns',
      permission: 'returns',
      hasSubmenu: false
    },
    {
      title: 'DASHBOARD.CARDS.RETURNS-HISTORY.TITLE',
      description: 'DASHBOARD.CARDS.RETURNS-HISTORY.DESCRIPTION',
      icon: 'fa-solid fa-clock-rotate-left',
      route: '/returns-history',
      permission: 'returns-history',
      hasSubmenu: false
    },
    {
      title: 'DASHBOARD.CARDS.RETURNS-TOTAL.TITLE',
      description: 'DASHBOARD.CARDS.RETURNS-TOTAL.DESCRIPTION',
      icon: 'fas fa-chart-pie',
      route: '/returns-total',
      permission: 'returns-total',
      hasSubmenu: false
    },
    {
      title: 'DASHBOARD.CARDS.SHIPMENT_REQUEST.TITLE',
      description: 'DASHBOARD.CARDS.SHIPMENT_REQUEST.DESCRIPTION',
      icon: 'fas fa-shipping-fast',
      route: '/shipment-request',
      permission: 'shipment-request',
      hasSubmenu: false
    },
    {
      title: 'DASHBOARD.CARDS.RETURN_REQUEST.TITLE',
      description: 'DASHBOARD.CARDS.RETURN_REQUEST.DESCRIPTION',
      icon: 'fas fa-undo',
      route: '/return-request',
      permission: 'return-request',
      hasSubmenu: false
    },
    {
      title: 'DASHBOARD.CARDS.ANAGRAFICA.TITLE',
      description: 'DASHBOARD.CARDS.ANAGRAFICA.DESCRIPTION',
      icon: 'fas fa-address-book',
      route: '/anagraphic',
      permission: 'anagraphic',
      hasSubmenu: false
    },
    {
      title: 'DASHBOARD.CARDS.SHIPMENT_MANAGEMENT.TITLE',
      description: 'DASHBOARD.CARDS.SHIPMENT_MANAGEMENT.DESCRIPTION',
      icon: 'fas fa-clipboard-list',
      route: '/shipment-management',
      permission: 'shipment-management',
      hasSubmenu: false
    },
    {
      title: 'DASHBOARD.CARDS.BORDEREAU.TITLE',
      description: 'DASHBOARD.CARDS.BORDEREAU.DESCRIPTION',
      icon: 'fas fa-list-check',
      route: '/loading-list',
      permission: 'loading-list',
      hasSubmenu: false
    },
    {
      title: 'DASHBOARD.CARDS.CHANGE-TOUR.TITLE',
      description: 'DASHBOARD.CARDS.CHANGE-TOUR.DESCRIPTION',
      icon: 'fas fa-route',
      route: '/change-tour',
      permission: 'change-tour',
      hasSubmenu: false
    },
    {
      title: 'DASHBOARD.CARDS.OVERVIEW-HARMONIZER.TITLE',
      description: 'DASHBOARD.CARDS.OVERVIEW-HARMONIZER.DESCRIPTION',
      icon: 'fas fa-pencil',
      route: '/overview-harmonizer',
      permission: 'overview-harmonizer',
      hasSubmenu: false
    },
    {
      title: 'DASHBOARD.CARDS.DISCREPANCY_LIST.TITLE',
      description: 'DASHBOARD.CARDS.DISCREPANCY_LIST.DESCRIPTION',
      icon: 'fas fa-exclamation-triangle',
      route: '/discrepancy-list',
      permission: 'discrepancy-list',
      hasSubmenu: false
    },
    {
      title: 'DASHBOARD.CARDS.PICKING_MANAGEMENT.TITLE',
      description: 'DASHBOARD.CARDS.PICKING_MANAGEMENT.DESCRIPTION',
      icon: 'fas fa-barcode',
      route: '/picking-management',
      permission: 'picking-management',
      hasSubmenu: false
    },
    {
      title: 'DASHBOARD.CARDS.OVERVIEW_WAREHOUSE.TITLE',
      description: 'DASHBOARD.CARDS.OVERVIEW_WAREHOUSE.DESCRIPTION',
      icon: 'fas fa-warehouse',
      route: '/overview-warehouse',
      permission: 'overview-warehouse',
      hasSubmenu: false
    },
    {
      title: 'DASHBOARD.CARDS.TRIP.TITLE',
      description: 'DASHBOARD.CARDS.TRIP.DESCRIPTION',
      icon: 'fas fa-list-check',
      route: '/trip-management',
      permission: 'trip-management',
      hasSubmenu: false
    },
    {
      title: 'DASHBOARD.CARDS.OVERVIEW_PICKING.TITLE',
      description: 'DASHBOARD.CARDS.OVERVIEW_PICKING.DESCRIPTION',
      icon: 'fas fa-magnifying-glass-chart',
      route: '/overview-picking',
      permission: 'overview-picking',
      hasSubmenu: false
    },
    {
      title: 'DASHBOARD.CARDS.STOCK.TITLE',
      description: 'DASHBOARD.CARDS.STOCK.DESCRIPTION',
      icon: 'fas fa-pallet',
      route: '/stock',
      permission: 'stock',
      hasSubmenu: false
    },
    // TODO: Finance non ancora rilasciato - voce di menu nascosta
    // {
    //   title: 'DASHBOARD.CARDS.FINANCE.TITLE',
    //   description: 'DASHBOARD.CARDS.FINANCE.DESCRIPTION',
    //   icon: 'fas fa-euro-sign',
    //   route: '/finance',
    //   permission: 'finance',
    //   hasSubmenu: false
    // },
    {
      title: 'DASHBOARD.CARDS.SYSTEM.TITLE',
      description: 'DASHBOARD.CARDS.SYSTEM.DESCRIPTION',
      icon: 'fas fa-cog',
      route: '/system',
      permission: 'system',
      hasSubmenu: true,
      isExpanded: false,
      submenu: [
        {
          title: 'SYSTEM.CARDS.WEBHOOK_MANAGEMENT.TITLE',
          icon: 'fas fa-plug',
          route: '/webhook-management',
          permission: 'webhook-management'
        },
        {
          title: 'SYSTEM.CARDS.DATA_EXCHANGE_MANAGEMENT.TITLE',
          icon: 'fas fa-exchange-alt',
          route: '/data-exchange-management',
          permission: 'data-exchange-management'
        },
        {
          title: 'SYSTEM.CARDS.OTM_MANAGEMENT.TITLE',
          icon: 'fas fa-truck-loading',
          route: '/otm-management',
          permission: 'otm-management'
        },
        {
          title: 'SYSTEM.CARDS.EOD_REPORT.TITLE',
          icon: 'fas fa-file-invoice',
          route: '/eod-report',
          permission: 'eod-report'
        },
        {
          title: 'SYSTEM.CARDS.PDF_MANAGEMENT.TITLE',
          icon: 'fas fa-file-pdf',
          route: '/pdf-management',
          permission: 'pdf-management'
        },
        {
          title: 'SYSTEM.CARDS.PRINT_DOCUMENTS.TITLE',
          icon: 'fas fa-print',
          route: '/print-documents',
          permission: 'print-documents'
        },
        {
          title: 'SYSTEM.CARDS.BARCODE_GENERATOR.TITLE',
          icon: 'fas fa-barcode',
          route: '/barcode-generator',
          permission: 'barcode-generator'
        },
        {
          title: 'SYSTEM.CARDS.IMAGES.TITLE',
          icon: 'fas fa-images',
          route: '/images',
          permission: 'images'
        },
        {
          title: 'SYSTEM.CARDS.DEALER_MASSIVE_INSERT.TITLE',
          icon: 'fas fa-file-excel',
          route: '/dealer-massive-insert',
          permission: 'dealer-massive-insert'
        }
      ]
    },
    // {
    //   title: 'DASHBOARD.CARDS.MANIFEST.TITLE',
    //   description: 'DASHBOARD.CARDS.MANIFEST.DESCRIPTION',
    //   icon: 'fas fa-clipboard-list',
    //   route: '/manifest',
    //   permission: 'manifest',
    //   hasSubmenu: false
    // },
    // {
    //   title: 'DASHBOARD.CARDS.SUPPORT.TITLE',
    //   description: 'DASHBOARD.CARDS.SUPPORT.DESCRIPTION',
    //   icon: 'fas fa-headset',
    //   route: '/support',
    //   permission: 'support',
    //   hasSubmenu: false
    // }
  ];

  constructor(
    private authService: AuthService,
    private router: Router,
    public functionService: FunctionService,
    private translate: TranslateService,
    private scheduledNoticeService: ScheduledNoticeService
  ) {}

  ngOnInit(): void {
    const stored = localStorage.getItem('userFunctions');

    if (stored) {
      const parsed = JSON.parse(stored);
      this.clientsBrands = parsed.clients;

      this.showBertaniVGILogos =
        this.clientsBrands?.length === 1 &&
        this.clientsBrands[0].clientCode === 'CLT00001';
    }

    this.selectedCategory = localStorage.getItem('selectedCategory') || 'products';
    this.searchInput = localStorage.getItem('searchInput') || '';
    this.startDate = localStorage.getItem('startDate') || '';
    this.endDate = localStorage.getItem('endDate') || '';
    
    // Sottoscrizione agli avvisi attivi
    this.noticeSubscription = this.scheduledNoticeService.activeNotice$.subscribe(
      notice => this.activeNotice = notice
    );
    
    // Controlla e attiva gli avvisi schedulati
    this.scheduledNoticeService.checkScheduledNotices();
  }

  ngOnDestroy(): void {
    this.noticeSubscription.unsubscribe();
  }

  ngAfterViewInit(): void {
    flatpickr('#startDateInput', {
      dateFormat: 'Y-m-d',
      locale: Italian,
      defaultDate: this.startDate || undefined,
      onChange: (selectedDates, dateStr) => {
        this.startDate = dateStr;
        localStorage.setItem('startDate', dateStr);
      }
    });

    flatpickr('#endDateInput', {
      dateFormat: 'Y-m-d',
      locale: Italian,
      defaultDate: this.endDate || undefined,
      onChange: (selectedDates, dateStr) => {
        this.endDate = dateStr;
        localStorage.setItem('endDate', dateStr);
      }
    });
    // initSnow('.snow-canvas', '.logo-img');
  }

  performSearch(event: Event): void {
    event.preventDefault();

    if (this.startDate && this.endDate && new Date(this.startDate) > new Date(this.endDate)) {
      alert('La data di inizio non può essere successiva alla data di fine.');
      return;
    }

    this.router.navigate(['/search'], {
      queryParams: {
        query: this.searchInput,
        category: this.selectedCategory,
        startDate: this.startDate,
        endDate: this.endDate,
      },
    });
  }

  changeLanguage(lang: string): void {
    this.translate.setDefaultLang(lang);
    this.translate.use(lang);
    localStorage.setItem('language', lang);
  }

  saveToLocalStorage(event: Event): void {
    const target = event.target as HTMLSelectElement;
    const selectedValue = target.value;
    localStorage.setItem('selectedCategory', selectedValue);
    this.selectedCategory = selectedValue;
  }

  saveSearchInput(): void {
    localStorage.setItem('searchInput', this.searchInput);
  }

  resetSearchInput(): void {
    this.searchInput = '';
    this.startDate = '';
    this.endDate = '';
    localStorage.removeItem('searchInput');
    localStorage.removeItem('startDate');
    localStorage.removeItem('endDate');

    // Resetta i Flatpickr
    (flatpickr('#startDateInput') as any).clear();
    (flatpickr('#endDateInput') as any).clear();
  }
  logout(): void {
    this.authService.logout();
  }
  
  // Funzione per mostrare/nascondere la barra di ricerca sui dispositivi mobili
  toggleSearch(): void {
    this.isSearchExpanded = !this.isSearchExpanded;
  }

  // Metodo per nascondere l'avviso importante
  dismissNotice(): void {
    this.scheduledNoticeService.dismissActiveNotice();
  }

  // Metodo per navigare e chiudere il dropdown
  navigateToRoute(route: string): void {
    this.router.navigate([route]);
    // Il dropdown si chiude automaticamente con Bootstrap
  }

  isCurrentRoute(route: string): boolean {
    return this.router.url === route;
  }

  // Metodo per espandere/comprimere le voci del menu
  toggleMenuExpansion(item: any, event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    
    if (item.hasSubmenu) {
      item.isExpanded = !item.isExpanded;
      
      // Chiudi tutti gli altri menu espansi
      this.menuItems.forEach(menuItem => {
        if (menuItem !== item && menuItem.hasSubmenu) {
          menuItem.isExpanded = false;
        }
      });
    }
  }

  // Metodo per navigare alle sottovoci
  navigateToSubmenu(route: string, event: Event): void {
    event.stopPropagation();
    
    // Naviga alla route
    this.router.navigate([route]);
    
    // Chiudi tutti i submenu espansi
    this.menuItems.forEach(menuItem => {
      if (menuItem.hasSubmenu) {
        menuItem.isExpanded = false;
      }
    });
    
    // Chiudi il dropdown Bootstrap usando metodi multipli per sicurezza
    setTimeout(() => {
      // Metodo 1: Rimuovi classe show dal dropdown
      const dropdownMenu = document.querySelector('.dropdown-menu.show');
      if (dropdownMenu) {
        dropdownMenu.classList.remove('show');
      }
      
      // Metodo 2: Rimuovi classe show dal bottone burger
      const burgerButton = document.querySelector('.btn-burger[aria-expanded="true"]');
      if (burgerButton) {
        burgerButton.setAttribute('aria-expanded', 'false');
        burgerButton.classList.remove('show');
      }
      
      // Metodo 3: Trigger click sul backdrop se presente
      const backdrop = document.querySelector('.dropdown-backdrop');
      if (backdrop) {
        (backdrop as HTMLElement).click();
      }
    }, 50);
  }

  // Mobile Menu Functions
  toggleMobileMenu(): void {
    this.mobileMenuOpen = !this.mobileMenuOpen;
    if (this.mobileMenuOpen) {
      document.body.style.overflow = 'hidden'; // Blocca lo scroll della pagina quando il menu è aperto
      document.body.style.position = 'fixed'; // Fissa il body
      document.body.style.width = '100%'; // Mantieni la larghezza
      document.body.style.touchAction = 'none'; // Previene i gesti touch
    } else {
      document.body.style.overflow = ''; // Ripristina lo scroll quando il menu è chiuso
      document.body.style.position = ''; // Ripristina la posizione
      document.body.style.width = ''; // Ripristina la larghezza
      document.body.style.touchAction = ''; // Ripristina i gesti touch
    }
  }

  closeMobileMenu(): void {
    this.mobileMenuOpen = false;
    document.body.style.overflow = ''; // Ripristina lo scroll
    document.body.style.position = ''; // Ripristina la posizione
    document.body.style.width = ''; // Ripristina la larghezza
    document.body.style.touchAction = ''; // Ripristina i gesti touch
  }

  closeMobileMenuIfNoSubmenu(item: any): void {
    if (!item.hasSubmenu) {
      this.closeMobileMenu();
    }
  }

  // Chiudi il menu quando la finestra viene ridimensionata a dimensioni desktop
  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    if (window.innerWidth > 768 && this.mobileMenuOpen) {
      this.closeMobileMenu();
    }
  }
}